import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { IllustrationStickerCheck } from '@xing-com/illustrations';
import { Tag as BaseTag } from '@xing-com/tag';
import {
  spaceXS,
  spaceS,
  spaceXL,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { Meta, BodyCopy } from '@xing-com/typography';

const Illustration = styled(IllustrationStickerCheck)`
  margin: 0 auto ${spaceXL} auto;
  width: 48px;
  height: 48px;
  flex: none;
`;

const Title = styled(BodyCopy)`
  font-weight: bold;
  margin-top: ${spaceXL};
  &:first-child {
    margin-top: 0;
  }
  margin-bottom: ${spaceXS};
`;

const Tag = styled(BaseTag)`
  margin-top: ${spaceS};
  width: fit-content;
  display: inline-flex;
  vertical-align: middle;
  margin-right: ${spaceS};
`;

const Note = styled(Meta)`
  color: ${xdlColorTextSecondary};
  margin: ${spaceXL} 0 0 0;
`;

const ScrollableContainer = styled.div`
  overflow-y: visible;
  overflow-x: hidden;
  padding: ${spaceXS};
`;

const AddButton = styled(Button)`
  flex: none;
  margin-top: ${spaceXL};
`;

export default {
  Title,
  Tag,
  Note,
  Illustration,
  AddButton,
  ScrollableContainer,
};
